module.exports = __webpack_public_path__ + "img/pr-5.73f63cac.png";